import Vue from 'vue';
import Vuex from 'vuex';
import permission from './modules/permission';
import user from './modules/user';
import goodsArchives from './modules/goodsArchives';
import app from './modules/app';
import getters from './getters';
import request from './modules/request';


Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
      permission,
      user,
      goodsArchives,
      app,
      request
    },
    getters
  });

export default store

